import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Tools.css";

const Tools = ({ onSubmit = () => {} }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log("Tools credentials submitted:", { username, password });

    const formData = { username, password };
    onSubmit(formData);

    // Redirect to tools list page
    navigate("/toolslist");
  };

  return (
    <div className="technology-selector">
      <div className="container">
        <header className="selector-header">
          <h1>Five9 Tools Authentication</h1>
          <p>Please enter your Five9 API User credentials to access tools</p>
        </header>

        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '40vh'
        }}>
          <div className="technology-card" style={{ 
            maxWidth: '400px',
            width: '100%'
          }}>
            <form onSubmit={handleSubmit}>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                marginBottom: '20px'
              }}>
                <label style={{
                  fontSize: '14px',
                  fontWeight: '600',
                  marginBottom: '8px',
                  color: '#333'
                }}>Username:</label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  style={{
                    padding: '12px',
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    fontSize: '14px',
                    transition: 'border-color 0.2s',
                    outline: 'none'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#1976d2'}
                  onBlur={(e) => e.target.style.borderColor = '#ddd'}
                  required
                  placeholder="Enter your Five9 API username"
                />
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                marginBottom: '24px'
              }}>
                <label style={{
                  fontSize: '14px',
                  fontWeight: '600',
                  marginBottom: '8px',
                  color: '#333'
                }}>Password:</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{
                    padding: '12px',
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    fontSize: '14px',
                    transition: 'border-color 0.2s',
                    outline: 'none'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#1976d2'}
                  onBlur={(e) => e.target.style.borderColor = '#ddd'}
                  required
                  placeholder="Enter your Five9 API password"
                />
              </div>
              <button type="submit" className="select-btn" style={{ width: '100%' }}>
                Access Tools
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tools;
